import socialProfiles from "./socialProfiles.json";

export const SOCIAL_PROFILES = socialProfiles;

export const activeSocialProfiles = Object.entries(SOCIAL_PROFILES)
  .filter(([, profile]) => Boolean(profile.url))
  .map(([id, profile]) => ({ id, ...profile }));

export const getSocialProfile = (id) => SOCIAL_PROFILES[id] || null;